(function(){
    angular
        .module('appback')
        .directive('ngInterpretacionform', interpreatcionform);

        interpreatcionform.$inject = ['$timeout','GenerallabService'];
        function interpreatcionform($timeout,GenerallabService){
            return {
	            scope: {
                  peticion: '=',
                  categoria: '=',
                  item: '='
              	},
	            link: function(scope, element, attrs) {
					 return $timeout(function () {
                        scope.generalLab = GenerallabService;
		            	//console.log(" simple res");
                        if(angular.isDefined(scope.categoria)){

                           scope.$watch('item.resultado.extra',function(newvalue,oldvalue){
                           	if(oldvalue!=newvalue){
			            		//console.log("oldVal",oldvalue);
	                               scope.generalLab.getInterpretacionesCategoria(scope.peticion,scope.categoria,true)
	                              //console.log("resultado sub");
	                       	}
                           },true)
                       }
			        });
				}
        	}
        }
})();